import { Badge, Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { Business } from 'services/@types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  businesses: Business[];
}

const statusColor: Record<string, string> = {
  active: 'green',
  trial: 'blue',
  cancelled: 'red',
  expired: 'gray',
  pending: 'orange',
  trial_expired: 'gray',
};

export default function RecentBusinessesCard({ businesses }: Props) {
  const { t } = useTranslation();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        {t('dashboard.recent_businesses')}
      </Text>
      {businesses.map((b) => (
        <Flex
          key={b.id}
          data-testid="business-row"
          justify="space-between"
          align="center"
          py="8px"
          borderBottom="1px solid"
          borderColor="gray.100"
          cursor="pointer"
          onClick={() => navigate(`/admin/businesses/detail/${b.id}`)}
        >
          <Box>
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {b.businessName}
            </Text>
            <Text color="gray.400" fontSize="xs">
              {b.email}
            </Text>
          </Box>
          <Flex align="center" gap="8px">
            <Badge
              colorScheme={statusColor[b.subscription?.type] || 'gray'}
              fontSize="xs"
            >
              {b.subscription?.type || '-'}
            </Badge>
            <Text color="gray.400" fontSize="xs">
              {b.createdAt ? new Date(b.createdAt).toLocaleDateString() : '-'}
            </Text>
          </Flex>
        </Flex>
      ))}
      {businesses.length === 0 && (
        <Text color="gray.400">{t('dashboard.no_data')}</Text>
      )}
    </Card>
  );
}
